module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-n-denim.211ef541.svg";